import Text from 'antd/lib/typography/Text';
import React from 'react';
import {css} from 'styled-components';
import {AppUser, Maybe, PlanActions, PlanDoc, PlanType} from '../../types';
import { div, palette } from '../../constants/styles';
import PlanStatusComponent from './PlanStatusComponent';
import DownloadPlanComponent from './DownloadPlanComponent';
import { useDispatch } from 'react-redux';
import {to_date_string} from "../../utils/misc";
import {message, Rate, Tag, Tooltip} from "antd";
import {has_access_to_study} from "../../utils/user";

type Props = PlanDoc & {
  user: Maybe<AppUser>
  border: boolean;
}

const StyledPlan = div`
display: flex;
justify-content: space-evenly;
width: 100%;
padding: 10px 2.5px;
${({ border }) => border && css`
    border-bottom: 1px solid ${palette.basicGray};
`}

`;

export const FixedWidth = div`
  width: 300px;
`;


export default function PlanComponent({user, created_at, stars, tags, id, user_name, building, error, plan_type, plans, border, success}: Props) {
  console.log(new Date(created_at));
  const dispatch = useDispatch();
  const openErrorModal = (id: string) => dispatch({type: PlanActions.SET_ERROR_DETAILS_MODAL, payload: {
    open: true,
    planId: id
  }});
  const plan_id = id;
  const get_color = (value: number): string => {
    let color = "";
    switch(value) {
      case 0:
        color = "#6A3805" // Bronze
        break;
      case 1:
        color = "#B4B4B4" // Platinum
        break;
      case 2:
        color = "#C9B037" // Gold
        break;
      default:
        color = "black"
        break;
    }
    return color;
  }
  return (
    <StyledPlan
      border={border}
    >
      <FixedWidth>
        <Text
            style={{
              maxWidth: '15%',
              wordWrap: 'break-word',
              minWidth: '200px'
            }}
        >
          {user_name ? user_name : "???"}
        </Text>
      </FixedWidth>
      <FixedWidth>
        <Text
        >
          {to_date_string(created_at)}
        </Text>
      </FixedWidth>
      <FixedWidth>
        <Text
        >
          {plan_type}
        </Text>
      </FixedWidth>
        {has_access_to_study(user) && <>
            <FixedWidth>
                <Rate count={3} disabled value={stars} defaultValue={0} />
            </FixedWidth>
            <FixedWidth style={{cursor: "pointer"}} onClick={()=> {
                // Create text to copy
                let copyText = `Productos que aplican para este usuario:
`
                let valuePrefix = ""
                let lastValue = 1000
                if (tags) {
                  tags.sort((a, b) => (a.value > b.value) ? -1 : 1)
                      .forEach(({ id , friendly_name, value }) => {
                        if (value < lastValue) {
                          if (value == 0) {
                            valuePrefix = '🥉'
                          } else if (value == 1) {
                            valuePrefix = '🥈'
                          } else if (value == 2) {
                            valuePrefix = '🥇'
                          }
                          copyText += `${valuePrefix} ${friendly_name}
`
                          lastValue = value
                        } else if (value == lastValue) {
                          copyText += `${valuePrefix} ${friendly_name}
`
                        }
                      })
                }
                navigator.clipboard.writeText(copyText)
                message.success('Productos aplicables copiados exitosamente');
            }}>
                <Tooltip title="Click para copiar">
                    {tags && (
                        tags.sort((a, b) => (a.value > b.value) ? -1 : 1)
                            .map(({ id , friendly_name, value }) => (
                                <Tag key={`${plan_id}-${id}`} color={get_color(value)} style={{height: "21px"}}>
                                    <p style={{fontSize: "10px"}}>{friendly_name}</p>
                                </Tag>
                            ))
                    )
                    }
                </Tooltip>
            </FixedWidth>
        </>}
      <FixedWidth>
        <PlanStatusComponent
          handleClick={(id: string) => openErrorModal(id)}
          planId={id}
          error={error}
          building={building}
          success={success}
        />
      </FixedWidth>
      <FixedWidth>
        {
          success ? (
              <DownloadPlanComponent
                plan_type={plan_type}
                user_name={user_name}
                plans={plans}
              />
          ) : (<Text>...</Text>)
        }
      </FixedWidth>
    </StyledPlan>
  );
}
